import { Stack } from '@mui/material';
import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { FC } from 'react';
import { ActivityDayHeaderSkeleton } from './ActivityDayHeaderSkeleton';
import { ActivityTimelineItemSkeleton } from './ActivityTimelineItemSkeleton';

export type ActivityDayGroupSkeletonProps = {
    itemCount?: number;
};

export const ActivityDayGroupSkeleton: FC<ActivityDayGroupSkeletonProps> = ({ itemCount = 3 }) => {
    return (
        <Stack gap={1}>
            <ActivityDayHeaderSkeleton />
            <Stack sx={{ borderRadius: '16px', overflow: 'hidden', ...liquidGlassRowShadowSx }}>
                <Stack sx={{ borderRadius: 'inherit', ...liquidGlassSurfaceFillSx }}>
                    {Array.from({ length: itemCount }).map((_, i) => (
                        <ActivityTimelineItemSkeleton key={i} showDivider={i > 0} />
                    ))}
                </Stack>
            </Stack>
        </Stack>
    );
};
